import { render, staticRenderFns } from "./BaseItemCompetitionSmall.vue?vue&type=template&id=47ab2e5c&scoped=true&"
import script from "./BaseItemCompetitionSmall.vue?vue&type=script&lang=js&"
export * from "./BaseItemCompetitionSmall.vue?vue&type=script&lang=js&"
import style0 from "./BaseItemCompetitionSmall.vue?vue&type=style&index=0&id=47ab2e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ab2e5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47ab2e5c')) {
      api.createRecord('47ab2e5c', component.options)
    } else {
      api.reload('47ab2e5c', component.options)
    }
    module.hot.accept("./BaseItemCompetitionSmall.vue?vue&type=template&id=47ab2e5c&scoped=true&", function () {
      api.rerender('47ab2e5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseItemCompetitionSmall.vue"
export default component.exports